import { useGetTopCard } from './useGetTopCard';

export const useCardIsVREligible = () => {
  const topCard = useGetTopCard();
  const travelBenefits = topCard?.travelBenefits || [];
  return travelBenefits.some((benefit) => benefit.name === 'SHR');
};
